import React, { useRef, useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/navigoDashboardStyles.scss";
import {
  Select,
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import { UserTypeFilter } from "./UserTypeFilter";
import FontIcon from "react-md/lib/FontIcons";
import OptionsIcon from "react-md-icon/dist/RoundMoreVert";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import Button from "react-md/lib/Buttons/Button";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import ColumnFilterPopover from "../../../../../components/common/ColumnFilterPopover/ColumnFilterPopover";
import NavigoDashboardUtils from "../services/NavigoDashboardUtils";
import Helper from "util/Helper";
import { TextField as TextField2 } from "react-md";
import intToTime12 from "../helper/intToTime12";
import { Col } from "react-flexbox-grid";
import RefreshButton from "../helper/RefreshButton";
import { CancelAppointmentDialog } from "./refund/CancelAppointmentDialog";
import { CancelAppointmentFlow } from "./refund/CancelAppointmentFlow";
import { useRefundDialog } from "./refund/useRefundDialog";
import { RefundDialog } from "./refund/RefundDialog";
import {
  getAppointmentPaymentStatusList,
  APPOINTMENT_PAYMENT_STATUS,
  NAVIGO_STATUS,
  SERVICE_TYPE,
  MODES,
  REFUND_STATUS,
  CANCEL_APP_OPTION,
  generalNavigoStatus,
  navigoLabtestStatus,
  hraStatuses,
  LAB_WORKFLOW_STATUSES,
  getStatusName,
  isEndStatus,
  isConsultation,
  opensCallNote,
} from "../helper/appointmentConstants";
/* phr's call note (v2 endpoints, its templates, its save -> send-to-chat ->
   lock flow) — the same modal the appointments-v2 board and the legacy details
   screen open, so the note is the same wherever a status is set. */
import CallNoteModal from "modules/patient/components/CallNoteModal";
import paymentStatusPendingIcon from "../../../../../assets/icons/payment/payment_status_pending.svg";
import paymentStatusPaidIcon from "../../../../../assets/icons/payment/payment_status_paid.svg";
import paymentStatusRequestedIcon from "../../../../../assets/icons/payment/payment_status_requested.svg";
import paymentStatusFailedIcon from "../../../../../assets/icons/payment/payment_status_failed.svg";
import paymentStatusSponsoredIcon from "../../../../../assets/icons/payment/payment_status_sponsored.svg";
import paymentStatusRefundedIcon from "../../../../../assets/icons/payment/payment_status_refunded.svg";

function NavigoDashboard(props) {
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [componentMounted, setComponentMounted] = useState(false);
  const navigoDashboardUtils = new NavigoDashboardUtils();
  const helper = new Helper();
  const [patientId, setPatientId] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [filterObj, setFilterObj] = useState({
    pageNum: 1,
    pageSize: 30,
    statusOrderSort: true,
  });
  const [onlyPageChange, setOnlyPageChange] = useState(false);
  const handleClick = (event, appointment) => {
    setAnchorEl(event.currentTarget);
    setMenuFor(appointment);
  };
  const [noAppointments, setNoAppointments] = useState(true);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [numFrom, setNumFrom] = useState(0);
  const [numTo, setNumTo] = useState(0);
  const [creationDateFrom, setCreationDateFrom] = useState(null);
  const [creationDateTo, setCreationDateTo] = useState(null);
  const [rescheduleDateFrom, setRescheduleDateFrom] = useState(null);
  const [rescheduleDateTo, setRescheduleDateTo] = useState(null);
  const [appointmentDateFrom, setAppointmentDateFrom] = useState(null);
  const [appointmentDateTo, setAppointmentDateTo] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openFilter, setOpenFilter] = useState(0);
  const [maxDate, setMaxDate] = useState("");
  const skip = useRef(30);
  const [searchPid, setSearchPid] = useState("");
  const [searchAppid, setSearchAppid] = useState("");
  const [searchPhoneCC, setSearchPhoneCC] = useState(91);
  const [searchPhoneNo, setSearchPhoneNo] = useState("");
  const [serviceProviderNameOptions, setServiceProviderNameOptions] = useState(
    [],
  );
  const [
    filterServiceProviderNameOptions,
    setFilterServiceProviderNameOptions,
  ] = useState([]);
  const [serviceProviderFilterMode, setServiceProviderFilterMode] =
    useState("include");
  const serviceProviderFilterIconRef = useRef(null);
  const [filterServiceCodeOptions, setFilterServiceCodeOptions] = useState([]);
  const [serviceCodeFilterMode, setServiceCodeFilterMode] = useState("include");
  const serviceCodeFilterIconRef = useRef(null);
  const [filterAccountCodeOptions, setFilterAccountCodeOptions] = useState([]);
  const [accountCodeFilterMode, setAccountCodeFilterMode] = useState("include");
  const accountCodeFilterIconRef = useRef(null);
  const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);
  const [filterPaymentStatusOptions, setFilterPaymentStatusOptions] = useState(
    [],
  );
  const [modesOptions, setModesOptions] = useState([]);
  const [filterModesOptions, setFilterModesOptions] = useState([]);
  const [serviceModeFilterMode, setServiceModeFilterMode] = useState("include");
  const serviceModeFilterIconRef = useRef(null);
  const [statusFilterValue, setStatusFilterValue] = useState([]);
  const [statusFilterMode, setStatusFilterMode] = useState("include");
  const statusFilterIconRef = useRef(null);
  const [updatingID, setUpdateID] = useState(0);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [serviceTypeSelected, setServiceTypeSelected] = useState(0);
  const [labelToProvidersMap, setLabelToProvidersMap] = useState({});
  const [removeFilters, setRemoveFilters] = useState(false);
  const [showCancelAppDialog, setShowCancelAppDialog] = useState(false);
  const [cancelAppOption, setCancelAppOption] = useState(0);
  const [appToBeCancelled, setAppToBeCancelled] = useState(null);
  // The restyled cancel flow, used only for the "Cancelled" status.
  const [appToBeCancelledNewFlow, setAppToBeCancelledNewFlow] = useState(null);
  /** The row whose call note is open after a status change, or null. */
  const [callNoteFor, setCallNoteFor] = useState(null);
  const [statusToBeApplied, setStatusToBeApplied] = useState(null);

  const allStatusList = useMemo(() => {
    const cancelArr = [{ value: NAVIGO_STATUS.CANCELLED, name: "Cancelled" }];
    const noShowArr = [{ value: NAVIGO_STATUS.NO_SHOW, name: "No show" }];

    const combined = generalNavigoStatus.concat(
      navigoLabtestStatus,
      hraStatuses,
      cancelArr,
      noShowArr,
    );

    const uniqueMap = new Map();

    combined.forEach((item) => {
      if (!uniqueMap.has(item.value)) {
        uniqueMap.set(item.value, item);
      }
    });

    return Array.from(uniqueMap.values());
  }, []);

  useEffect(() => {
    handleGetAllAppointments();
    handleFetchServiceProviderNameOpt("");
    addPaymentStatusName();
    getModes();
    setComponentMounted(true);
  }, []);

  useEffect(() => {
    if (componentMounted && onlyPageChange == true) {
      setFilterObj({ ...filterObj, pageNum: pageNum });
    }
  }, [onlyPageChange]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  useEffect(() => {
    if (componentMounted) {
      skip.current = 30;
      handleGetAllAppointments();
    }
  }, [filterObj]);

  const handleGetAllAppointments = (type = 1, btnType = 0) => {
    setLoading(true);

    navigoDashboardUtils.fetchAppointments(
      filterObj,
      (res) => {
        setOnlyPageChange(false);
        if (res && res.appointments && res.appointments.length > 0) {
          let allList = [];

          allList = res.appointments.map((service) => {
            return { ...service };
          });
          let localNumFrom, localNumTo;
          if (type === 1) {
            localNumFrom = 1;
            localNumTo = Math.min(30, res.resultCount);
          } else if (type === 2) {
            if (btnType === 0) {
              localNumTo = numFrom - 1;
              localNumFrom = Math.max(numFrom - 30, 1);
            } else {
              localNumFrom = numTo + 1;
              localNumTo = Math.min(numTo + 30, res.resultCount);
            }
          } else if (type === 3) {
            localNumFrom = numFrom;
            localNumTo = numTo;
          }
          setAppointmentsList([...allList]);
          setNoAppointments(false);
          setNumFrom(localNumFrom);
          setNumTo(localNumTo);
          setTotalCount(res.totalCount);
          setLoading(false);
        } else {
          setAppointmentsList([]);
          setNoAppointments(true);
          setLoading(false);
        }
        setRemoveFilters(false);
      },
      (err) => {
        setLoading(false);
        setAppointmentsList([]);
        setNoAppointments(true);
        setRemoveFilters(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const addPaymentStatusName = () => {
    setPaymentStatusOptions(getAppointmentPaymentStatusList());
  };

  const changeScreen = (opt, ele) => {
    if (opt === 1) {
      props.setView(1, null);
    }
    if (opt === 2) {
      props.setView(2, {
        appId: ele.id,
      });
    }
  };

  const handlePrevNextAppoint = (arg) => {
    setOnlyPageChange(true);
    if (arg) {
      setPageNum((prevPage) => prevPage + 1);
    } else {
      if (pageNum > 1) {
        setPageNum((prevPage) => (prevPage > 1 ? prevPage - 1 : 1));
      }
    }
  };

  useEffect(() => {
    if (!patientId && !appointmentId && !phoneNumber && componentMounted) {
      handleGetAllAppointments();
    }
  }, [patientId, appointmentId, phoneNumber]);

  useEffect(() => {
    if (componentMounted) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceTypeID: serviceTypeSelected === 0 ? [] : [serviceTypeSelected],
      });
      setPageNum(1);
    }
  }, [serviceTypeSelected]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      const expanded = statusFilterValue.flatMap((e) =>
        e.value === NAVIGO_STATUS.SCHEDULED_LEGACY ||
        e.value === NAVIGO_STATUS.SCHEDULED
          ? [NAVIGO_STATUS.SCHEDULED_LEGACY, NAVIGO_STATUS.SCHEDULED]
          : [e.value],
      );
      const next = { ...filterObj, pageNum: 1 };
      if (statusFilterMode === "exclude") {
        next.ignoreStatus = expanded;
        delete next.status;
      } else {
        next.status = expanded;
        delete next.ignoreStatus;
      }
      setFilterObj(next);
      setPageNum(1);
    }
  }, [statusFilterValue, statusFilterMode]);
  //-------------------------------------

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      const ids = filterServiceProviderNameOptions.map((e) => e.id);
      const next = { ...filterObj, pageNum: 1 };
      if (serviceProviderFilterMode === "exclude") {
        next.ignoreServiceProviderID = ids;
        delete next.serviceProviderID;
      } else {
        next.serviceProviderID = ids;
        delete next.ignoreServiceProviderID;
      }
      setFilterObj(next);
      setPageNum(1);
    }
  }, [filterServiceProviderNameOptions, serviceProviderFilterMode]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      const ids = filterServiceCodeOptions.map((e) => e.id);
      const next = { ...filterObj, pageNum: 1 };
      if (serviceCodeFilterMode === "exclude") {
        next.ignoreServiceID = ids;
        delete next.serviceID;
      } else {
        next.serviceID = ids;
        delete next.ignoreServiceID;
      }
      setFilterObj(next);
      setPageNum(1);
    }
  }, [filterServiceCodeOptions, serviceCodeFilterMode]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      const codes = filterAccountCodeOptions.map((e) => e.accountCode);
      const next = { ...filterObj, pageNum: 1 };
      if (accountCodeFilterMode === "exclude") {
        next.ignoreAccountCode = codes;
        delete next.accountCode;
      } else {
        next.accountCode = codes;
        delete next.ignoreAccountCode;
      }
      setFilterObj(next);
      setPageNum(1);
    }
  }, [filterAccountCodeOptions, accountCodeFilterMode]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        paymentStatus: filterPaymentStatusOptions.flatMap((e) => {
          return e.id === APPOINTMENT_PAYMENT_STATUS.FAILED
            ? [
                APPOINTMENT_PAYMENT_STATUS.FAILED,
                APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED,
                APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED,
              ]
            : [e.id];
        }),
      });
      setPageNum(1);
    }
  }, [filterPaymentStatusOptions]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      const next = { ...filterObj, pageNum: 1 };
      if (serviceModeFilterMode === "exclude") {
        next.ignoreServiceMode = filterModesOptions;
        delete next.serviceMode;
      } else {
        next.serviceMode = filterModesOptions;
        delete next.ignoreServiceMode;
      }
      setFilterObj(next);
      setPageNum(1);
    }
  }, [filterModesOptions, serviceModeFilterMode]);
  //-------------------------------------
  function filterUniqueByServiceProviderName(arr) {
    const seen = new Map();
    return arr.filter((e) => {
      const name =
        e.serviceTypeId == SERVICE_TYPE.HEALTH_CHECKUP
          ? e?.checkupInfo?.identityDetails?.name
          : e.serviceTypeId == SERVICE_TYPE.CONSULTATION
            ? e?.consultationInfo?.identityDetails?.name
            : null;

      if (!name || seen.has(name)) return false;

      seen.set(name, true);
      return true;
    });
  }
  function filterUniqueByAccountCode(arr) {
    const seen = new Map();
    return arr.filter(
      (item) => !seen.has(item.accountCode) && seen.set(item.accountCode, true),
    );
  }
  //-------------------------------------
  const handleFetchServiceProviderNameOpt = (str) => {
    navigoDashboardUtils.getServiceProvidersByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        nameMatch: [],
        name: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.providers && res.providers.length > 0) {
          let allList = [];

          allList = res.providers.map((service) => {
            return { ...service };
          });
          // allList = filterUniqueByServiceProviderName(allList);
          setServiceProviderNameOptions(allList);
        } else {
          setServiceProviderNameOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoAppointments(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const formatProviderLabel = (provider) => {
    if (!provider) return "";
    const id = provider.id;
    switch (provider.serviceTypeId) {
      case SERVICE_TYPE.DENTAL:
        return `(${id}) ${provider?.dentalInfo?.identityDetails?.name} - ${provider?.dentalInfo?.address?.city} - ${provider?.dentalInfo?.address?.landmark}`;
      case SERVICE_TYPE.GYM:
        return `(${id}) ${provider?.gymInfo?.identityDetails?.name}`;
      case SERVICE_TYPE.VACCINE:
        return `(${id}) ${provider?.vaccineInfo?.identityDetails?.name} - ${provider?.vaccineInfo?.address?.city} - ${provider?.vaccineInfo?.address?.landmark}`;
      case SERVICE_TYPE.HEALTH_CHECKUP:
        return `(${id}) ${provider?.checkupInfo?.identityDetails?.name} - ${provider?.checkupInfo?.address?.city} - ${provider?.checkupInfo?.address?.landmark}`;
      case SERVICE_TYPE.CONSULTATION:
        return `(${id}) ${provider?.consultationInfo?.identityDetails?.name}`;
      default:
        return "";
    }
  };

  const loadServiceProviderOptions = (q, offset, limit) =>
    new Promise((resolve) => {
      const pageNum = Math.floor(offset / limit) + 1;
      navigoDashboardUtils.getServiceProvidersByFilter(
        { pageNum, pageSize: limit, nameMatch: [], name: q || "" },
        (res) => {
          const providers = (res && res.providers) || [];
          const total =
            typeof res?.totalCount === "number"
              ? res.totalCount
              : offset + providers.length;
          resolve({
            options: providers.map((p) => ({
              id: p.id,
              label: formatProviderLabel(p),
            })),
            total,
            hasMore: offset + providers.length < total,
          });
        },
        () => resolve({ options: [], total: 0, hasMore: false }),
      );
    });

  const loadServiceCodeOptions = (q, offset, limit) =>
    new Promise((resolve) => {
      const pageNum = Math.floor(offset / limit) + 1;
      navigoDashboardUtils.getServicesByFilter(
        { pageNum, pageSize: limit, nameMatch: [], name: q || "" },
        (res) => {
          const services = (res && res.services) || [];
          const total =
            typeof res?.totalCount === "number"
              ? res.totalCount
              : offset + services.length;
          resolve({
            options: services.map((s) => ({ id: s.id, label: s.name })),
            total,
            hasMore: offset + services.length < total,
          });
        },
        () => resolve({ options: [], total: 0, hasMore: false }),
      );
    });

  const loadAccountCodeOptions = (q, offset, limit) =>
    new Promise((resolve) => {
      const pageNum = Math.floor(offset / limit) + 1;
      navigoDashboardUtils.getAccountsByFilter(
        {
          pageNum,
          pageSize: limit,
          accountCodeMatch: [],
          accountCode: q || "",
        },
        (res) => {
          const accounts = filterUniqueByAccountCode(
            (res && res.accounts) || [],
          );
          const total =
            typeof res?.totalCount === "number"
              ? res.totalCount
              : offset + accounts.length;
          resolve({
            options: accounts.map((a) => ({
              id: a.accountCode,
              label: a.accountCode,
            })),
            total,
            hasMore: offset + accounts.length < total,
          });
        },
        () => resolve({ options: [], total: 0, hasMore: false }),
      );
    });

  const filterByPhone = () => {
    const onResponse = (res) => {
      if (res != null && res.length > 0) {
        setFilterObj({
          ...filterObj,
          pageNum: 1,
          patientIds: res.map((e) => e.id),
        });
        setPageNum(1);
      } else if (res != null && res.length == 0) {
        EventService.emit("showError", {
          message: `No patient with this phone number`,
        });
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.filterByPhone(
      searchPhoneCC,
      searchPhoneNo,
      onResponse,
      onError,
    );
  };
  const { dialogState, setDialogState, openRefundDialog, handleClose } =
    useRefundDialog();

  function resetValuesAfterCancelAppDialogCloses() {
    setAppToBeCancelled(null);
    setStatusToBeApplied(null);
    setShowCancelAppDialog(false);
    setCancelAppOption(0);
  }

  useEffect(() => {
    if (cancelAppOption === CANCEL_APP_OPTION.NONE) {
      resetValuesAfterCancelAppDialogCloses();
      return;
    }
    if (cancelAppOption === CANCEL_APP_OPTION.JUST_CANCEL) {
      // just cancel appointment
      handleAppointmentStatusChange(statusToBeApplied, appToBeCancelled);
      resetValuesAfterCancelAppDialogCloses();
    }
    if (
      cancelAppOption === CANCEL_APP_OPTION.CANCEL_WITH_REFUND ||
      cancelAppOption === CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND
    ) {
      if (cancelAppOption === CANCEL_APP_OPTION.CANCEL_WITH_REFUND) {
        // requesting refund with appointment cancel
        openRefundDialog({
          appointmentObj: appToBeCancelled,
          isOnlyRefund: false,
          forceRefund:
            appToBeCancelled.refundStatus ===
            REFUND_STATUS.ELIGIBLE_NOT_APPLICABLE, // while cancelling, the refund was eligible but not applicable due to some reason (eg within 24hr cancel), still you want to forcefully give refund to the user
          newRefundStatus: REFUND_STATUS.ELIGIBLE_APPLICABLE,
          statusToBeApplied,
          onRefresh,
        });
        resetValuesAfterCancelAppDialogCloses();
      } else {
        // no refund with appointment cancel
        openRefundDialog({
          appointmentObj: appToBeCancelled,
          isOnlyRefund: false,
          forceRefund: false,
          newRefundStatus: REFUND_STATUS.ELIGIBLE_NOT_APPLICABLE,
          statusToBeApplied,
          onRefresh,
        });
        resetValuesAfterCancelAppDialogCloses();
      }
    }
  }, [cancelAppOption]);

  const handleSelectChange = (value, ele) => {
    if (
      value === NAVIGO_STATUS.CANCELLED ||
      value === NAVIGO_STATUS.NO_SHOW ||
      value === NAVIGO_STATUS.DECLINED ||
      value === NAVIGO_STATUS.NOT_ELIGIBLE
    ) {
      fetchLatestAptDetailsBeforeCancelOrNoShow(ele.id, value);
    } else {
      handleAppointmentStatusChange(value, ele);
    }
  };
  const handleAppointmentStatusChange = (value, ele) => {
    setUpdateID(ele.id);
    let body = {
      appointmentID: ele.id,
      reportUrl: "",
      status: value,
    };
    const onResponse = (res) => {
      setUpdateID(0);
      handleGetAllAppointments();
      /* A status change that lands is the one moment a call outcome is known,
         so the note opens on it (Nittin, 2026-09-28) — only on success, never
         on the error arm below, which knows no outcome. Not for a
         non-consultation, and not for the two "Not answered" outcomes where
         nobody was reached (opensCallNote); the row menu's own call note still
         opens it by hand in every case. */
      if (opensCallNote(ele, value)) setCallNoteFor(ele);
    };
    const onError = (err) => {
      setUpdateID(0);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.handleStatusUpdate(body, onResponse, onError);
  };
  const getModes = () => {
    navigoDashboardUtils.getModes(
      (res) => {
        if (res != null) {
          setServiceTypes(res);
          const allModes = [...new Set(res.flatMap((mode) => mode.modes))];

          setModesOptions(allModes);
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const onRefresh = () => {
    handleGetAllAppointments();
  };

  const areFiltersApplied = () => {
    if (
      filterObj?.createdAt?.from != null ||
      filterObj?.createdAt?.to != null ||
      filterObj?.appointmentDate?.from != null ||
      filterObj?.appointmentDate?.to != null ||
      filterObj?.serviceID?.length > 0 ||
      filterObj?.ignoreServiceID?.length > 0 ||
      filterObj?.serviceMode?.length > 0 ||
      filterObj?.ignoreServiceMode?.length > 0 ||
      filterObj?.serviceProviderID?.length > 0 ||
      filterObj?.ignoreServiceProviderID?.length > 0 ||
      filterObj?.accountCode?.length > 0 ||
      filterObj?.ignoreAccountCode?.length > 0 ||
      filterObj?.paymentStatusResponse?.length > 0 ||
      filterObj?.status?.length > 0 ||
      filterObj?.ignoreStatus?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const resetFilters = () => {
    let resetFilterObj = filterObj;
    delete resetFilterObj.createdAt;
    delete resetFilterObj.appointmentDate;
    delete resetFilterObj.appointmentDate;
    delete resetFilterObj.serviceID;
    delete resetFilterObj.ignoreServiceID;
    delete resetFilterObj.serviceMode;
    delete resetFilterObj.ignoreServiceMode;
    delete resetFilterObj.serviceProviderID;
    delete resetFilterObj.ignoreServiceProviderID;
    delete resetFilterObj.accountCode;
    delete resetFilterObj.ignoreAccountCode;
    delete resetFilterObj.paymentStatusResponse;
    delete resetFilterObj.status;
    delete resetFilterObj.ignoreStatus;

    setFilterObj({
      ...resetFilterObj,
      pageNum: 1,
    });
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };
  useEffect(() => {
    if (removeFilters === true) {
      setFilterServiceProviderNameOptions([]);
      setFilterServiceCodeOptions([]);
      setFilterAccountCodeOptions([]);
      setFilterPaymentStatusOptions([]);
      setFilterModesOptions([]);
      setStatusFilterValue([]);
      setStatusFilterMode("include");
      setServiceCodeFilterMode("include");
      setAccountCodeFilterMode("include");
      setServiceModeFilterMode("include");
      setServiceProviderFilterMode("include");
      resetFilters();
    }
  }, [removeFilters]);
  useEffect(() => {
    if (componentMounted) {
      onRefresh();
    }
  }, [props.dashboardKeyReload]);

  const getProfileIcon = (type) => {
    switch (type) {
      case 1: // Premium
        return { bg: "#b8893f" };
      case 2: // HR
        return { bg: "#f4b400" };
      case 3: // QA
        return { bg: "#9c8df2" };
      case 4: // Sensitive
        return { bg: "#e57373" };
      case 0:
      default:
        return { bg: "#9e9e9e" };
    }
  };
  const getProfileLabel = (type) => {
    switch (type) {
      case 1:
        return "Premium User";
      case 2:
        return "HR Representative";
      case 3:
        return "QA User";
      case 4:
        return "Sensitive User";
      case 0:
      default:
        return "Default User";
    }
  };

  // User type filter: an empty selection drops profileTypes from the request
  // rather than sending an empty list.
  const applyProfileTypesFilter = (profileTypes) => {
    const nextFilter = { ...filterObj, pageNum: 1 };
    if (profileTypes.length > 0) {
      nextFilter.profileTypes = profileTypes;
    } else {
      delete nextFilter.profileTypes;
    }
    setFilterObj(nextFilter);
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };

  const fetchLatestAptDetailsBeforeCancelOrNoShow = (appId, value) => {
    setUpdateID(appId);
    const onResponse = (res) => {
      if (
        res != null &&
        res.appointments != null &&
        res.appointments.length != 0
      ) {
        setStatusToBeApplied(value);
        if (
          value === NAVIGO_STATUS.CANCELLED ||
          value === NAVIGO_STATUS.NO_SHOW ||
          value === NAVIGO_STATUS.NOT_ELIGIBLE ||
          value === NAVIGO_STATUS.DECLINED
        ) {
          // Every status that reaches this function runs the restyled flow,
          // which applies statusToBeApplied rather than a hardcoded status.
          setAppToBeCancelledNewFlow(res.appointments[0]);
        } else {
          setAppToBeCancelled(res.appointments[0]);
          setShowCancelAppDialog(true);
        }
      }
      setUpdateID(0);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setUpdateID(0);
    };
    navigoDashboardUtils.fetchAppointments(
      {
        pageNum: 1,
        pageSize: 1,
        appointmentId: appId,
        statusOrderSort: true,
      },
      onResponse,
      onError,
    );
  };

  return (
    <div className="navigo-module-dashboard-table-container">
      <div className="navigo-appoint-container">
        <div className="navigo-appoint-section-8">
          <div
            className="navigo-appoint-section-1"
            onClick={() => {
              helper.navigateTo(props, "/");
            }}
          >
            <FontIcon id="back_button" style={{ fontSize: "36px" }}>
              arrow_back
            </FontIcon>
          </div>
          <h1 className="navigo-appoint-section-2">Appointments</h1>
          <RefreshButton onRefresh={onRefresh} loading={loading} />
          <div className="navigo-appoint-section-4-bottom-button-container">
            <Button
              raised
              className={"navigo-module-button-save-enabled"}
              onClick={() => {
                changeScreen(1, null);
              }}
            >
              {"Add new"}
            </Button>
          </div>
        </div>
        {/* ________________ */}
        <div
          className="navigo-module-buttons-container"
          style={{ marginTop: "20px" }}
        >
          <div className="mp-phone-container" style={{ marginLeft: "15px" }}>
            <div style={{ width: "200px", marginRight: "20px" }}>
              <Select
                value={serviceTypeSelected}
                onChange={(event) => setServiceTypeSelected(event.target.value)}
                className="navigo-service-type-select"
                displayEmpty
                renderValue={(value) =>
                  value === 0
                    ? "Search via service type"
                    : serviceTypes.find((s) => s.id === value)?.name
                }
              >
                <MenuItem value={0}>Show all</MenuItem>
                {serviceTypes.map((ser) => (
                  <MenuItem key={ser.id} value={ser.id}>
                    {ser.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
          <TextField2
            id="patient_id"
            lineDirection="left"
            style={{ width: "120px" }}
            placeholder="Patient ID"
            type="text"
            value={searchPid}
            onChange={(e) => {
              let value = e.replace(/\D/g, "");
              if (value.length > 8) return;
              setSearchPid(value == "" ? "" : Number(value));
              if (value == "") {
                let removedFilterObj = filterObj;
                delete removedFilterObj.patientId;
                setFilterObj({
                  ...removedFilterObj,
                  pageNum: 1,
                });
              }
            }}
          />
          <div className="navigo-module-buttons-right-alignment">
            <Button
              raised
              className={
                searchPid == ""
                  ? "navigo-module-button-save-disabled"
                  : "navigo-module-button-save-enabled"
              }
              disabled={searchPid == ""}
              onClick={() => {
                if (searchPid != "") {
                  setFilterObj({
                    ...filterObj,
                    pageNum: 1,
                    patientId: searchPid,
                  });
                  setPageNum(1);
                }
              }}
            >
              {"Search"}
            </Button>
          </div>
          <TextField2
            id="appointment_id"
            lineDirection="left"
            style={{ width: "120px", marginLeft: "15px" }}
            placeholder="Appointment ID"
            type="text"
            value={searchAppid}
            onChange={(e) => {
              let value = e.replace(/\D/g, "");
              if (value.length > 8) return;
              setSearchAppid(value == "" ? "" : Number(value));
              if (value == "") {
                let removedFilterObj = filterObj;
                delete removedFilterObj.appointmentId;
                setFilterObj({
                  ...removedFilterObj,
                  pageNum: 1,
                });
              }
            }}
          />
          <div className="navigo-module-buttons-right-alignment">
            <Button
              raised
              className={
                searchAppid == ""
                  ? "navigo-module-button-save-disabled"
                  : "navigo-module-button-save-enabled"
              }
              disabled={searchAppid == ""}
              onClick={() => {
                if (searchAppid != "") {
                  setFilterObj({
                    ...filterObj,
                    pageNum: 1,
                    appointmentId: searchAppid,
                  });
                  setPageNum(1);
                }
              }}
            >
              {"Search"}
            </Button>
          </div>
          <div className="mp-phone-container" style={{ marginLeft: "15px" }}>
            <div style={{ width: "50px", marginRight: "20px" }}>
              <Select
                value={searchPhoneCC}
                placeholder="+91"
                onChange={(event) => setSearchPhoneCC(event.target.value)}
                className="navigo-country-code-select"
              >
                <MenuItem value={91}>+91</MenuItem>
                <MenuItem value={27}>+27</MenuItem>
                <MenuItem value={63}>+63</MenuItem>
                <MenuItem value={987}>+987</MenuItem>
              </Select>
            </div>
            <div style={{ flex: "1" }}>
              <TextField2
                id={`phone_number`}
                type="text"
                lineDirection="left"
                style={{ width: "120px" }}
                placeholder={`Phone no`}
                value={searchPhoneNo}
                onChange={(elem) => {
                  let value = elem.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setSearchPhoneNo(value == "" ? "" : Number(value));
                    if (value == "") {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.patientIds;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                    }
                  }
                }}
              />
            </div>
          </div>
          <div className="navigo-module-buttons-right-alignment">
            <Button
              raised
              className={
                searchPhoneNo == ""
                  ? "navigo-module-button-save-disabled"
                  : "navigo-module-button-save-enabled"
              }
              disabled={searchPhoneNo == ""}
              onClick={() => {
                filterByPhone();
              }}
            >
              {"Search"}
            </Button>
          </div>
        </div>

        <div className="navigo-appoint-section-5">
          <div className="navigo-appoint-section-5-grid-container">
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                User
                <br />
                type
              </p>
              <img
                src={
                  filterObj?.profileTypes?.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                alt="Filter by user type"
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(11);
                }}
              />
              {openFilter === 11 && (
                <UserTypeFilter
                  selected={filterObj?.profileTypes ?? []}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onApply={applyProfileTypesFilter}
                />
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Phone no
                <br />
                &nbsp;
              </p>
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section">
              <p>
                Appointment
                <br /> ID
              </p>
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section">
              <p>
                Patient <br /> ID
              </p>
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Patient <br />
                name
              </p>
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Creation <br /> date
              </p>
              <img
                src={
                  filterObj?.createdAt?.from || filterObj?.createdAt?.to
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                  <div className="navigo-appointment-date-range-filter ">
                    <p>From</p>
                    <TextField
                      type="date"
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setCreationDateFrom(v.target.value);
                        }
                      }}
                      inputProps={{ max: maxDate }}
                      value={creationDateFrom}
                    ></TextField>
                  </div>
                  <div className="navigo-appointment-date-range-filter ">
                    <p>To</p>
                    <TextField
                      type="date"
                      defaultValue={""}
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setCreationDateTo(v.target.value);
                        }
                      }}
                      inputProps={{ max: maxDate }}
                      value={creationDateTo}
                    ></TextField>
                  </div>
                  <Button
                    className=""
                    style={{
                      padding: "3px",
                      margin: "0px 5px",
                      backgroundColor: "#c3c3c3",
                    }}
                    onClick={() => {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        createdAt: {
                          from: moment(creationDateFrom)
                            .utc()
                            .startOf("day")
                            .add(1, "day")
                            .toISOString(),

                          to: moment(creationDateTo)
                            .utc()
                            .endOf("day")
                            .add(1, "day")
                            .toISOString(),
                        },
                      });
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    Go
                  </Button>
                  <Button
                    className=""
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.createdAt;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setCreationDateFrom(null);
                      setCreationDateTo(null);
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    <FontIcon className="">close</FontIcon>
                  </Button>
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Appointment <br /> date
              </p>
              <img
                src={
                  filterObj?.appointmentDate?.from ||
                  filterObj?.appointmentDate?.to
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(3);
                }}
              />
              {openFilter === 3 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                  <div className="navigo-appointment-date-range-filter ">
                    <p>From</p>
                    <TextField
                      type="date"
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setAppointmentDateFrom(v.target.value);
                        }
                      }}
                      // inputProps={{ max: maxDate }}
                      value={appointmentDateFrom}
                    ></TextField>
                  </div>
                  <div className="navigo-appointment-date-range-filter ">
                    <p>To</p>
                    <TextField
                      type="date"
                      defaultValue={""}
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setAppointmentDateTo(v.target.value);
                        }
                      }}
                      // inputProps={{ max: maxDate }}
                      value={appointmentDateTo}
                    ></TextField>
                  </div>
                  <Button
                    className=""
                    style={{
                      padding: "3px",
                      margin: "0px 5px",
                      backgroundColor: "#c3c3c3",
                    }}
                    onClick={() => {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        appointmentDate: {
                          from: moment(appointmentDateFrom)
                            .utc()
                            .startOf("day")
                            .add(1, "day")
                            .toISOString(),

                          to: moment(appointmentDateTo)
                            .utc()
                            .endOf("day")
                            .add(1, "day")
                            .toISOString(),
                        },
                      });
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    Go
                  </Button>
                  <Button
                    className=""
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.appointmentDate;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setAppointmentDateFrom(null);
                      setAppointmentDateTo(null);
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    <FontIcon className="">close</FontIcon>
                  </Button>
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Time
                <br /> slot
              </p>
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Service <br /> code
              </p>
              <img
                ref={serviceCodeFilterIconRef}
                src={
                  filterServiceCodeOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(9);
                }}
              />
              {openFilter === 9 && (
                <ColumnFilterPopover
                  anchorRef={serviceCodeFilterIconRef}
                  title="Filter by Service Code"
                  searchPlaceholder="Search services..."
                  loadOptions={loadServiceCodeOptions}
                  selectedIds={filterServiceCodeOptions.map((s) => s.id)}
                  selectedItems={filterServiceCodeOptions.map((s) => ({
                    id: s.id,
                    label: s.name,
                  }))}
                  mode={serviceCodeFilterMode}
                  onApply={(ids, items, mode) => {
                    const next = items.map((it) => ({
                      id: it.id,
                      name: it.label,
                    }));
                    setServiceCodeFilterMode(mode);
                    setFilterServiceCodeOptions(next);
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                />
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Service <br /> mode
              </p>
              <img
                ref={serviceModeFilterIconRef}
                src={filterModesOptions.length > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <ColumnFilterPopover
                  anchorRef={serviceModeFilterIconRef}
                  title="Filter by Service Mode"
                  searchPlaceholder="Search modes..."
                  options={modesOptions.map((m) => ({ id: m, label: m }))}
                  selectedIds={filterModesOptions}
                  mode={serviceModeFilterMode}
                  onApply={(ids, items, mode) => {
                    setServiceModeFilterMode(mode);
                    setFilterModesOptions(ids);
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                />
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Service provider <br /> name
              </p>
              <img
                ref={serviceProviderFilterIconRef}
                src={
                  filterServiceProviderNameOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(7);
                }}
              />
              {openFilter === 7 && (
                <ColumnFilterPopover
                  anchorRef={serviceProviderFilterIconRef}
                  title="Filter by Service Provider"
                  searchPlaceholder="Search providers..."
                  loadOptions={loadServiceProviderOptions}
                  selectedIds={filterServiceProviderNameOptions.map(
                    (p) => p.id,
                  )}
                  selectedItems={filterServiceProviderNameOptions.map((p) => ({
                    id: p.id,
                    label: p.label || formatProviderLabel(p),
                  }))}
                  mode={serviceProviderFilterMode}
                  onApply={(ids, items, mode) => {
                    const next = items.map((it) => ({
                      id: it.id,
                      label: it.label,
                    }));
                    setServiceProviderFilterMode(mode);
                    setFilterServiceProviderNameOptions(next);
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                />
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Account <br /> code
              </p>
              <img
                ref={accountCodeFilterIconRef}
                src={
                  filterAccountCodeOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(8);
                }}
              />
              {openFilter === 8 && (
                <ColumnFilterPopover
                  anchorRef={accountCodeFilterIconRef}
                  title="Filter by Account Code"
                  searchPlaceholder="Search account codes..."
                  loadOptions={loadAccountCodeOptions}
                  selectedIds={filterAccountCodeOptions.map(
                    (a) => a.accountCode,
                  )}
                  selectedItems={filterAccountCodeOptions.map((a) => ({
                    id: a.accountCode,
                    label: a.accountCode,
                  }))}
                  mode={accountCodeFilterMode}
                  onApply={(ids, items, mode) => {
                    const next = items.map((it) => ({ accountCode: it.id }));
                    setAccountCodeFilterMode(mode);
                    setFilterAccountCodeOptions(next);
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                />
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Pay <br /> status
              </p>
              <img
                src={
                  filterPaymentStatusOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(10);
                }}
              />
              {openFilter === 10 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                  <Autocomplete
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="navigo-multiple-limit-payment-status-name"
                    options={paymentStatusOptions.filter(
                      (item) => item.id !== APPOINTMENT_PAYMENT_STATUS.REFUNDED,
                    )}
                    getOptionLabel={(option) => option.label}
                    value={filterPaymentStatusOptions}
                    onChange={(e, v) => {
                      if (v) {
                        setFilterPaymentStatusOptions(v);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchAccountCodeOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Status <br /> &nbsp;
              </p>
              <img
                ref={statusFilterIconRef}
                src={statusFilterValue.length > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <ColumnFilterPopover
                  anchorRef={statusFilterIconRef}
                  title="Filter by Status"
                  searchPlaceholder="Search statuses..."
                  options={allStatusList.map((s) => ({
                    id: s.value,
                    label: s.name,
                  }))}
                  selectedIds={statusFilterValue.map((s) => s.value)}
                  mode={statusFilterMode}
                  onApply={(ids, items, mode) => {
                    const next = allStatusList.filter((s) =>
                      ids.includes(s.value),
                    );
                    setStatusFilterMode(mode);
                    setStatusFilterValue(next);
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                />
              )}
            </div>
            {areFiltersApplied() && (
              <div
                onClick={() => {
                  setRemoveFilters(true);
                }}
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                }}
              >
                <FontIcon style={{ fontSize: "22px" }}>
                  highlight_remove
                </FontIcon>
              </div>
            )}
          </div>
        </div>
        <div className="navigo-appoint-section-6">
          {appointmentsList && appointmentsList.length > 0 && (
            <div className="navigo-appoint-bottom-bar">
              <Button
                className="navigo-appoint-bottom-bar-button"
                onClick={() => {
                  handlePrevNextAppoint(0);
                }}
                disabled={pageNum == 1 || loading}
              >
                <FontIcon className="navigo-count-icon">arrow_drop_up</FontIcon>
              </Button>
              <div className="navigo-appoint-bottom-bar-text">
                Showing&nbsp;
                <span
                  style={{
                    color: "#ef7c01",
                  }}
                >
                  {(pageNum - 1) * pageSize + 1}&nbsp;- &nbsp;
                  {totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount}
                </span>
                <span>&nbsp;of&nbsp;</span>
                <span>{` ${totalCount}`}</span>
              </div>
              <Button
                className="navigo-appoint-bottom-bar-button"
                onClick={() => {
                  handlePrevNextAppoint(1);
                }}
                disabled={
                  loading ||
                  pageNum * pageSize > totalCount ||
                  (totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount) == totalCount
                }
              >
                <FontIcon className="navigo-count-icon">
                  arrow_drop_down
                </FontIcon>
              </Button>
            </div>
          )}
          {loading == false && (
            <div className="navigo-appoint-section-6-list">
              {appointmentsList &&
                appointmentsList.map((ele) => {
                  return (
                    <div
                      className="navigo-appoint-section-6-grid-container"
                      key={ele.id}
                      style={{
                        backgroundColor: ele.isPatientPlanActive
                          ? "transparent"
                          : "#FFDEDC",
                      }}
                    >
                      <div className="general-font-class">
                        {ele.patientProfileType !== undefined ? (
                          <Tooltip
                            title={getProfileLabel(ele.patientProfileType)}
                            position="top"
                          >
                            <div
                              className="profile-icon"
                              style={{
                                backgroundColor: getProfileIcon(
                                  ele.patientProfileType,
                                ).bg,
                              }}
                            >
                              <span className="material-icons">person</span>
                            </div>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </div>
                      <div className="general-font-class ">
                        {`+${ele.phoneNumber.countryCode}-${ele.phoneNumber.phoneNo}`}
                      </div>
                      <div className="general-font-class">
                        <div
                          onClick={() => {
                            if (ele.id) {
                              changeScreen(2, ele);
                            }
                          }}
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {`${ele.id}`}
                        </div>
                      </div>

                      <div className="general-font-class ">
                        {ele.bookedFor == 0 ? ele.patientID : ele.bookedFor}
                      </div>
                      <div className="general-font-class">
                        {
                          /* The patient's HEALTH RECORD — bridge's phr record,
                             /patient-record/:patientId (App.js) — in the SAME
                             tab, as a router Link (Nittin, 2026-09-25); it
                             opened the legacy patients/new-bridge screen in a
                             new one. WHOSE record: the person the appointment
                             was BOOKED FOR when that is a family member, which
                             is the name this cell prints, and the patient
                             themselves when bookedFor is 0 — the same choice
                             the old link made. */
                          <Link
                            className="general-font-class general-cursor-pointer navigo-appointment-break-word-class"
                            /* …carrying THIS row's appointment, so an Rx or a
                               health plan created from the record maps back to
                               it (Nittin, 2026-09-28). */
                            to={`/patient-record/${
                              ele.bookedFor === 0
                                ? ele.patientID
                                : ele.bookedFor
                            }${ele.id ? `?appointmentId=${ele.id}` : ""}`}
                          >
                            {ele.patientName}
                          </Link>
                        }
                      </div>
                      <div className="general-font-class">
                        {moment.utc(ele.createdAt).format("DD MMM YYYY")}
                      </div>
                      <div className="general-font-class">
                        {ele?.serviceTypeID == SERVICE_TYPE.GYM
                          ? "-"
                          : moment
                              .utc(ele.appointmentDate)
                              .format("DD MMM YYYY")}
                      </div>
                      <div className="general-font-class">
                        {ele?.serviceTypeID == SERVICE_TYPE.GYM
                          ? "-"
                          : intToTime12(ele.timeSlot)}
                      </div>
                      <div className="general-font-class">
                        {ele?.serviceID > 0 ? (
                          <a
                            className="general-font-class general-cursor-pointer navigo-appointment-break-word-class"
                            href={`/service_module?view=2&mode=view&serviceId=${ele?.serviceID}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {ele?.serviceCode}
                          </a>
                        ) : (
                          ele?.serviceCode
                        )}
                      </div>
                      <div className="general-font-class">{ele.mode}</div>
                      <div className="general-font-class">
                        {`(${
                          ele.vendorDoctorId === 0
                            ? ele.serviceProviderID
                            : ele.vendorDoctorId
                        }) ${ele.serviceProviderName}`}
                        &nbsp;
                        {serviceProviderNameOptions.length > 0 &&
                          ele.serviceTypeID === SERVICE_TYPE.HEALTH_CHECKUP &&
                          (() => {
                            const match = serviceProviderNameOptions.find(
                              (e) => e.id === ele.serviceProviderID,
                            );
                            const address = match?.checkupInfo?.address;
                            const city = address?.city;
                            const landmark = address?.landmark;

                            return city && landmark
                              ? `(${city} - ${landmark})`
                              : city
                                ? `(${city})`
                                : landmark
                                  ? `(${landmark})`
                                  : null;
                          })()}
                      </div>
                      <div className="general-font-class">
                        {ele.accountCode}
                      </div>
                      <div className="general-font-class">
                        {ele?.paymentStatusResponse !== undefined &&
                          ele?.paymentStatusResponse !== null && (
                            <Tooltip
                              title={
                                paymentStatusOptions.find(
                                  (s) => s.id === ele.paymentStatusResponse,
                                )?.label ||
                                (ele.paymentStatusResponse ===
                                APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED
                                  ? "Link Expired"
                                  : ele.paymentStatusResponse ===
                                      APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED
                                    ? "Link Cancelled"
                                    : "")
                              }
                              enterDelay={0}
                              enterNextDelay={0}
                            >
                              <img
                                src={
                                  ele.paymentStatusResponse ===
                                  APPOINTMENT_PAYMENT_STATUS.PENDING
                                    ? paymentStatusPendingIcon
                                    : ele.paymentStatusResponse ===
                                        APPOINTMENT_PAYMENT_STATUS.COMPLETE
                                      ? paymentStatusPaidIcon
                                      : ele.paymentStatusResponse ===
                                          APPOINTMENT_PAYMENT_STATUS.INITIATED
                                        ? paymentStatusRequestedIcon
                                        : ele.paymentStatusResponse ===
                                              APPOINTMENT_PAYMENT_STATUS.FAILED ||
                                            ele.paymentStatusResponse ===
                                              APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED ||
                                            ele.paymentStatusResponse ===
                                              APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED
                                          ? paymentStatusFailedIcon
                                          : ele.paymentStatusResponse ===
                                              APPOINTMENT_PAYMENT_STATUS.SPONSORED
                                            ? paymentStatusSponsoredIcon
                                            : ele.paymentStatusResponse ===
                                                APPOINTMENT_PAYMENT_STATUS.REFUNDED
                                              ? paymentStatusRefundedIcon
                                              : null
                                }
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (ele.id) {
                                    changeScreen(2, ele);
                                  }
                                }}
                              />
                            </Tooltip>
                          )}
                      </div>

                      <div className="navigo-appoint-section-6-grid-status">
                        <div className="navigo-appoint-section-6-grid-status">
                          {!isEndStatus(ele.status) ? (
                            <Select
                              disabled={updatingID == ele.id ? true : false}
                              labelId="navigo-appoint-status-select"
                              id="appointment_select_status"
                              value={ele.status}
                              onChange={(e) => {
                                if (
                                  e.target.value === NAVIGO_STATUS.COMPLETED ||
                                  e.target.value ===
                                    NAVIGO_STATUS.REPORT_GENERATED
                                ) {
                                  handleSelectChange(e.target.value, ele);
                                } else {
                                  handleSelectChange(e.target.value, ele);
                                }
                              }}
                              label="Status"
                              className={`navigo-dashboard-select-css navigo-status-selector ${
                                ele.status === NAVIGO_STATUS.COMPLETED
                                  ? "progress-class"
                                  : `${
                                      ele.status === NAVIGO_STATUS.CANCELLED
                                        ? "closed-class"
                                        : `${
                                            ele.status ===
                                            NAVIGO_STATUS.CONFIRMED
                                              ? "invalid-class"
                                              : ele.status ===
                                                  NAVIGO_STATUS.IN_PROGRESS
                                                ? "pending-class"
                                                : "progress-class"
                                          }`
                                    }`
                              }`}
                            >
                              {ele.mode != MODES.HOME_SAMPLE && (
                                <MenuItem
                                  value={NAVIGO_STATUS.SCHEDULED_LEGACY}
                                  disabled={
                                    ele.status == NAVIGO_STATUS.COMPLETED ||
                                    ele.status ===
                                      NAVIGO_STATUS.RESCHEDULE_REQUESTED
                                      ? true
                                      : false
                                  }
                                  style={{
                                    borderBottom: "1px solid #d8d8d8",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                    fontFamily: "Montserrat",
                                  }}
                                >
                                  Scheduled
                                </MenuItem>
                              )}

                              {ele.serviceTypeID !== SERVICE_TYPE.GYM &&
                                ele.mode != MODES.HOME_SAMPLE &&
                                hraStatuses
                                  .filter(
                                    (st) =>
                                      !LAB_WORKFLOW_STATUSES.includes(st.value),
                                  )
                                  .map((st) => (
                                    <MenuItem
                                      value={st.value}
                                      style={{
                                        borderBottomLeftRadius: "8px",
                                        borderBottomRightRadius: "8px",
                                        fontWeight: "600",
                                        paddingLeft: "5px",
                                        fontFamily: "Montserrat",
                                      }}
                                    >
                                      {st.name}
                                    </MenuItem>
                                  ))}
                              {ele.mode === MODES.HOME_SAMPLE &&
                                navigoLabtestStatus.map((st) => {
                                  return (
                                    <MenuItem
                                      key={st.value}
                                      value={st.value}
                                      disabled={
                                        st.value ==
                                        NAVIGO_STATUS.RESCHEDULE_REQUESTED
                                      }
                                      style={{
                                        borderBottomLeftRadius: "8px",
                                        borderBottomRightRadius: "8px",
                                        fontWeight: "600",
                                        paddingLeft: "5px",
                                        fontFamily: "Montserrat",
                                        borderBottom: "1px solid #d8d8d8",
                                        display: `${
                                          st.value ==
                                          NAVIGO_STATUS.RESCHEDULE_REQUESTED
                                            ? "none"
                                            : "block"
                                        }`,
                                      }}
                                      className="general-navigo-status-select-class"
                                    >
                                      {st.name}
                                    </MenuItem>
                                  );
                                })}

                              {ele.mode === MODES.HOME_SAMPLE && (
                                <MenuItem
                                  value={NAVIGO_STATUS.SCHEDULED_LEGACY}
                                  disabled
                                  style={{
                                    display: `none`,
                                  }}
                                >
                                  Scheduled
                                </MenuItem>
                              )}

                              {/* Lab workflow statuses are only selectable for
                                  home sample mode, but an appointment of any
                                  other mode can still be moved to one from the
                                  lab side. Render a hidden item so the current
                                  status has a matching option and its name is
                                  shown instead of a blank selector. */}
                              {ele.mode !== MODES.HOME_SAMPLE &&
                                LAB_WORKFLOW_STATUSES.includes(ele.status) && (
                                  <MenuItem
                                    value={ele.status}
                                    disabled
                                    style={{
                                      display: `none`,
                                    }}
                                  >
                                    {getStatusName(ele.status)}
                                  </MenuItem>
                                )}
                              {ele.serviceTypeID !== SERVICE_TYPE.GYM && (
                                <MenuItem
                                  value={NAVIGO_STATUS.NO_SHOW}
                                  style={{
                                    borderBottom: "1px solid #d8d8d8",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                    fontFamily: "Montserrat",
                                  }}
                                  disabled={
                                    ele.status ===
                                    NAVIGO_STATUS.RESCHEDULE_REQUESTED
                                      ? true
                                      : false
                                  }
                                >
                                  No show
                                </MenuItem>
                              )}
                              {ele.serviceTypeID === SERVICE_TYPE.GYM && (
                                <MenuItem
                                  value={NAVIGO_STATUS.COMPLETED}
                                  style={{
                                    borderBottom: "1px solid #d8d8d8",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                    fontFamily: "Montserrat",
                                  }}
                                  disabled={
                                    ele.status ===
                                    NAVIGO_STATUS.RESCHEDULE_REQUESTED
                                      ? true
                                      : false
                                  }
                                >
                                  Completed
                                </MenuItem>
                              )}
                              <MenuItem
                                value={NAVIGO_STATUS.CANCELLED}
                                style={{
                                  borderBottom: "1px solid #d8d8d8",
                                  borderTopLeftRadius: "8px",
                                  borderTopRightRadius: "8px",
                                  fontWeight: "600",
                                  paddingLeft: "5px",
                                  fontFamily: "Montserrat",
                                }}
                              >
                                Cancelled
                              </MenuItem>
                            </Select>
                          ) : ele.status === NAVIGO_STATUS.COMPLETED &&
                            ele.serviceTypeID === SERVICE_TYPE.GYM ? (
                            <Select
                              disabled={updatingID == ele.id ? true : false}
                              labelId="navigo-appoint-status-select"
                              id="navigo-appoint-status-select-id"
                              value={ele.status}
                              onChange={(e) => {
                                handleSelectChange(e.target.value, ele);
                              }}
                              label="Status"
                              // className="navigo-dashboard-select-css navigo-status-selector progress-class"
                              className={`navigo-dashboard-select-css navigo-status-selector ${"closed-new-class"}`}
                            >
                              <MenuItem
                                value={NAVIGO_STATUS.COMPLETED}
                                disabled
                              >
                                Completed
                              </MenuItem>
                              <MenuItem value={NAVIGO_STATUS.CANCELLED}>
                                Cancel
                              </MenuItem>
                            </Select>
                          ) : (
                            <div
                              className={`${
                                ele.status === NAVIGO_STATUS.CONFIRMED
                                  ? "navigo-appoint-non-select-status-invalid"
                                  : "navigo-appoint-non-select-status-closed"
                              } `}
                            >
                              <span>{getStatusName(ele.status)}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <IconButton
                        id="three_dots_button"
                        onClick={(e) => handleClick(e, ele)}
                        className="navigo-appoint-section-6-grid-edit-call"
                      >
                        <OptionsIcon />
                      </IconButton>
                    </div>
                  );
                })}
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem
                  onClick={() => {
                    changeScreen(2, menuFor);
                    setAnchorEl(null);
                  }}
                >
                  Appointment details
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    /* phr's call note (CallNoteModal, v2 endpoints), the same
                       modal a status change opens below and the same one the
                       appointments-v2 board's row menu opens — so the note is
                       identical wherever it is written (Nittin, 2026-09-28).
                       The ROW goes in, not a patient id: the modal keys itself
                       on `bookedFor || patientID` exactly as the old dialog
                       did, and it needs the appointment for its templates. */
                    setCallNoteFor(menuFor);
                    setAnchorEl(null);
                  }}
                >
                  Add callnote
                </MenuItem>
              </Menu>
            </div>
          )}

          {loading && <GlobalSkeletonLoader />}
          {loading === false && noAppointments && (
            <div className="no-appointments-container">
              <p>No appointment found!</p>
            </div>
          )}
        </div>
        {openBackdrop && (
          <div
            className="navigo-appointment-backdrop-class"
            onClick={() => {
              setOpenFilter(0);
              setOpenBackdrop(false);
            }}
          ></div>
        )}
      </div>
      {showCancelAppDialog && (
        <CancelAppointmentDialog
          state={
            //means refund is eligible and applicable so open cancel with refund.
            //PARTIALLY_REFUNDED lands here too: a refund already exists but the
            //remaining balance is still refundable, and only this arm offers a refund.
            appToBeCancelled.refundStatus ===
              REFUND_STATUS.ELIGIBLE_APPLICABLE ||
            appToBeCancelled.refundStatus === REFUND_STATUS.PARTIALLY_REFUNDED
              ? CANCEL_APP_OPTION.CANCEL_WITH_REFUND
              : appToBeCancelled.refundStatus ===
                  REFUND_STATUS.ELIGIBLE_NOT_APPLICABLE // means refund is eligible but not applicable due to some reason (eg within 24hr cancel) so open cancel without refund
                ? CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND
                : CANCEL_APP_OPTION.JUST_CANCEL // // else open just cancel appointment
          }
          show={showCancelAppDialog}
          setCancelAppOption={setCancelAppOption}
          setShowCancelAppDialog={setShowCancelAppDialog}
          appToBeCancelled={appToBeCancelled}
        />
      )}
      {
        <RefundDialog
          dialogState={dialogState}
          setDialogState={setDialogState}
          handleClose={handleClose}
        />
      }
      {appToBeCancelledNewFlow && (
        <CancelAppointmentFlow
          appointment={appToBeCancelledNewFlow}
          statusToBeApplied={statusToBeApplied}
          onClose={() => {
            setAppToBeCancelledNewFlow(null);
            setStatusToBeApplied(null);
          }}
          /* After the money decision, not over it: the flow closes itself and
             the note follows, exactly as an ordinary status change does — for a
             CONSULTATION only. `isConsultation` rather than `opensCallNote`
             because every status that reaches this flow is a cancel-family one,
             never one of the two the other rule excludes, and
             `statusToBeApplied` is cleared by onClose. */
          onCompleted={() => {
            onRefresh();
            if (isConsultation(appToBeCancelledNewFlow)) {
              setCallNoteFor(appToBeCancelledNewFlow);
            }
          }}
        />
      )}

      {/* Keyed on the person the appointment is FOR — this screen's own
          `bookedFor == 0 ? patientID : bookedFor` rule (:2074-2078), the same
          one the details screen and the v2 board use — and on THIS appointment,
          which is what the note's templates read. */}
      {callNoteFor ? (
        <CallNoteModal
          patient={{
            id: callNoteFor.bookedFor || callNoteFor.patientID,
            firstName: callNoteFor.patientName || "",
            lastName: "",
          }}
          appointment={callNoteFor}
          onClose={() => setCallNoteFor(null)}
        />
      ) : null}
    </div>
  );
}

export default NavigoDashboard;
